export default __webpack_public_path__ + "static/media/home-slider1.c4185ac0.svg";